import { render, staticRenderFns } from "./ReferralContextMenu.vue?vue&type=template&id=48e36c1c"
import script from "./ReferralContextMenu.vue?vue&type=script&lang=js"
export * from "./ReferralContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports